module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_pp23_3016.a1da6ccf.png";